export default __webpack_public_path__ + "static/media/error.44496ad1.png";